import { TICKET_LISTING } from "./type";

const initalState = {
    ticketsList: null,
};

const ticketsListingReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case TICKET_LISTING:
            return {
                ...state,
                ticketsList: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default ticketsListingReducer;
